export const tokenEndpoint = "/token";
export const logoutEndpoint = "/api/-1/logout";
export const userDetailsEndpoint = "/api/userdetails";
export const forgotPasswordEndpoint = "/auth/credentials";
export const changePasswordEndpoint = "/api/password";
export const auditTrailEndpoint = "/api/-1/audittrailrecord";
export const changeUserPasswordEndpoint = "/api/password/user";
